import LoadScript from "../utils/LoadScript";
export default class BlockMovie {

	static init() {

		this.playerYoutube = document.querySelectorAll('.player-youtube');
		this.playerVimeo = document.querySelectorAll('.player-vimeo');

		if( this.playerYoutube.length > 0 ){
			LoadScript.load( 'https://www.youtube.com/iframe_api', this.initPlayerYoutube.bind(this) );
		}

		if( this.playerVimeo.length > 0 ){
			LoadScript.load( 'https://player.vimeo.com/api/player.js', this.initPlayerVimeo.bind(this) );
		}

	}

	static initPlayerYoutube(){

		this.playerYoutube.forEach( (youtube) => {

			let el = youtube;
			let videoID = el.dataset.videoId;
			let player = el.closest('.movie');

			if( !player.querySelector('img') ) {
				let poster = "https://img.youtube.com/vi/" + videoID + "/hqdefault.jpg";
				let img = document.createElement('img');
				img.src = poster;
				player.append(img);
			}

			let youtubePlayer = null;
			player.addEventListener('click', () => {
				if ( !player.classList.contains('player-load') ) {
					player.classList.add('player-load');
					player.classList.add('playing');
					youtubePlayer = new YT.Player(videoID, {
						height: '360',
						width: '640',
						videoId: videoID,
						playerVars: {
							'autoplay': 0,
							'showinfo': 0,
							'modestbranding': 1,
							'rel': 0,
							'enablejsapi': 1
						},
						events: {
							'onReady': (event) => {
								event.target.playVideo();
							}
						}
					});
				} else {
					youtubePlayer.playVideo();
				}
			});

		});

	}

	static initPlayerVimeo(){

		this.playerVimeo.forEach( (vimeo) => {

			let el = vimeo;
			let videoID = el.dataset.videoId;
			let url = el.dataset.videoUrl;
			let player = el.closest('.movie');

			if( !player.querySelector('img') ) {
				const xhttp = new XMLHttpRequest();
				xhttp.onload = function () {
					let poster = xhttp.response.thumbnail_url;
					let img = document.createElement('img');
					img.src = poster;
					player.append(img);
				};
				xhttp.responseType = 'json';
				xhttp.open("GET", 'https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(url), true);
				xhttp.send();
			}

			let playerVimeo = new Vimeo.Player(videoID, { id : videoID });

			playerVimeo.on("pause", () => {
				player.classList.remove('playing');
			});

			playerVimeo.on("play", () => {
				player.classList.add('playing');
			});

			player.addEventListener('click', () => {
				if ( !player.classList.contains('player-load') ) {
					player.classList.add('player-load');
				}
				playerVimeo.play();
			});

		});

	}

}
